/** Browser tab titles by route, in Bulgarian like the rest of the admin. */
export const APP_TITLE = "HappyPetNet администрация";

const PAGE_TITLES = {
  "/dashboard": "Табло",
  "/professional/vets": "Ветеринарни лекари",
  "/professional/clinics": "Ветеринарни клиники",
  "/professional/groomers": "Грумъри",
  "/professional/hotels": "Хотели",
  "/professional/pet-sitters": "Гледачи",
  "/professional/pet-walkers": "Разхождачи на кучета",
  "/professional/all": "Всички специалисти",
  "/professional/services": "Услуги",
  "/pet-owners/parents": "Стопани",
  "/pet-owners/pets": "Домашни любимци",
  "/shelters": "Приюти",
  "/shelters/pets": "Домашни любимци в приюти",
  "/bookings": "Резервации",
  "/bookings/pending": "Чакащи резервации",
  "/bookings/subscription": "Абонаментни резервации",
  "/bookings/coupons": "Купони / Ваучери",
  "/bookings/initiated-bookings": "Започнати резервации",
  "/accounting/report": "Отчет за транзакции",
  "/accounting/invoicing": "За фактуриране",
  "/accounting/profpayments": "Отбелязване на плащания",
  "/accounting/invoices": "Издадени фактури",
  "/accounting/accountants": "Експорт на НАП файл",
  "/accounting/received": "Разписки",
  "/financial-settings/subscriptions": "Абонаменти",
  "/financial-settings/transaction-fees": "Такси за транзакции",
  "/blog": "Статии",
  "/admins": "Администратори",
  "/marketing-pages": "Маркетингови страници",
  "/promo-banners": "Промо лента",
  "/testimonials": "Отзиви",
  "/promotions": "Промоции",
  "/comments": "Коментари",
  "/faq": "Често задавани въпроси",
  "/redirects": "Пренасочвания",
  "/translation-glossary": "Речник за преводи",
  "/site-updates": "Обновяване на сайта",
  "/subscribers": "Абонати",
  "/logs": "Одитен журнал",
  "/login": "Вход",
  "/register": "Регистрация",
  "/forgot-password": "Забравена парола",
};

/** "<page> | HappyPetNet администрация", or just the app title for unknown routes. */
export const pageTitle = (pathname = "") => {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  const page = PAGE_TITLES[path] || PAGE_TITLES[path.replace(/\/[^/]+$/, "")];
  return page ? `${page} | ${APP_TITLE}` : APP_TITLE;
};
